import { render, staticRenderFns } from "./AzrPlayerInventoryComponent.vue?vue&type=template&id=0490a8da&scoped=true"
import script from "./AzrPlayerInventoryComponent.vue?vue&type=script&lang=ts"
export * from "./AzrPlayerInventoryComponent.vue?vue&type=script&lang=ts"
import style0 from "./AzrPlayerInventoryComponent.vue?vue&type=style&index=0&id=0490a8da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0490a8da",
  null
  
)

export default component.exports